const isLocalHostname = (hostname) => ['localhost', '127.0.0.1'].includes(hostname);

const getBrowserOrigin = () => {
  if (typeof window === 'undefined') return 'http://localhost:3000';
  return window.location.origin;
};

const getBaseUrl = () => {
  const explicitBaseUrl = process.env.REACT_APP_API_BASE_URL;
  if (explicitBaseUrl) return explicitBaseUrl;

  const origin = getBrowserOrigin();
  if (typeof window !== 'undefined' && isLocalHostname(window.location.hostname)) {
    return 'http://localhost:3000/api';
  }

  return `${origin}/api`;
};

export const BASE_URL = getBaseUrl();
export const SOCKET_URL = BASE_URL.replace(/\/api$/, '');

export async function apiFetch(path, options = {}, token = null) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  const text = await res.text();

  let json;
  try {
    json = JSON.parse(text);
  } catch {
    throw new Error(`Server error (${res.status})`);
  }

  if (!res.ok) {
    // Attach status + payload so callers can act on structured failures
    // (an expired driver invite explains itself from `error.data`).
    const error = new Error(json.message || 'Request failed');
    error.status = res.status;
    error.data = json.data || null;
    error.code = json.code || json.data?.code || null;
    throw error;
  }
  return json;
}
